export const OBJECTIVES_TITLE = 'Objectives'
export const LESSON_CONCEPTS_TITLE = 'Lesson Concepts'
